// extracted by mini-css-extract-plugin
module.exports = {"cube":"Spinner_cube__2ZI-V","sk-foldCubeAngle":"Spinner_sk-foldCubeAngle__39EkD","cube2":"Spinner_cube2__Hisrx","cube3":"Spinner_cube3__3tU4y","cube4":"Spinner_cube4__3JXl8"};